export default "__VITE_ASSET__708a677e__"